import { render } from "./HowToUsePage.vue?vue&type=template&id=6c49fb70&scoped=true"
import script from "./HowToUsePage.vue?vue&type=script&lang=js"
export * from "./HowToUsePage.vue?vue&type=script&lang=js"

import "./HowToUsePage.vue?vue&type=style&index=0&id=6c49fb70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c49fb70"]])

export default __exports__